const styles = (theme) => ({
  breadCrumbs: {
    marginBottom: 56,
    '@media(max-width: 767px)': {
      marginBottom: 24,
    },
  },
  breadCrumbList: {
    padding: 0,
    margin: 0,
    display: 'flex',
    alignItems: 'center',
  },
  breadCrumbItem: {
    padding: 0,
    width: 'auto',
    '& svg': {
      width: 30,
      fontSize: theme.typography.fontSize20,
      '@media(max-width: 767px)': {
        fontSize: theme.typography.fontSize18,
      },
    },
  },
  breadCrumbLink: {
    color: theme.palette.secondary.main,
    fontSize: theme.typography.fontSize14,
    lineHeight: '1.6',
    fontWeight: theme.typography.fontWeightSemiBold,
    cursor: 'pointer',
    '@media(max-width: 767px)': {
      fontSize: theme.typography.fontSize15,
    },
  },
  breadCrumbText: {
    color: theme.palette.text.primary,
    fontSize: theme.typography.fontSize14,
    lineHeight: '1.6',
    '@media(max-width: 767px)': {
      fontSize: theme.typography.fontSize15,
    },
  },
});

export default styles;
